import { lazy } from 'react';

export const StripeuserPage = lazy(() => import('./page-list'));

export const StripeuserCreateUrl = lazy(() => import('./create-stripeurl'));